/**
 * CoursesFilter
 * ======================================
 * - filters .carousel-card items by data-tags attribute
 * - toggles is-active on filter buttons
 */

const FILTER = '.js-courses-filter'

class CoursesFilter {
  constructor() {
    document.querySelectorAll(FILTER).forEach((nav) => {
      nav.addEventListener('click', (e) => {
        e.preventDefault()
        const btn = e.target.closest('a')
        if (!btn) return

        const tag = btn.dataset.tag
        const cols = nav.closest('.courses__cols, .section--courses').querySelector('.courses__cols')

        nav.querySelectorAll('a').forEach(b => b.classList.remove('is-active'))
        btn.classList.add('is-active')

        if (!cols) return

        cols.querySelectorAll('.carousel-card').forEach((card) => {
          if (!tag || card.dataset.tags.split(' ').includes(tag)) {
            card.hidden = false
          } else {
            card.hidden = true
          }
        })
      })
    })
  }
}

new CoursesFilter()
